import * as Sentry from "@sentry/react"

Sentry.init({
    dsn: _SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.5,
    ignoreErrors: [
        // 忽略掉https://sentry.hypergryph.com/organizations/hypergryph/issues/45779/?project=17
        /@hg\/one-account/,
        // 忽略掉https://sentry.hypergryph.com/organizations/hypergryph/issues/46133/?project=17
        /^undefined is not an object \(evaluating 'this._audioElem.play\(\).catch'\)$/,
        /^TypeError: Cannot read property 'play' of undefined$/,
        // 忽略掉https://sentry.hypergryph.com/organizations/hypergryph/issues/46145/?project=17
        /^window\.android\.unLoad is not a function$/,
        /^TypeError: window\.android\.unLoad is not a function$/,
        // 忽略掉https://sentry.hypergryph.com/organizations/hypergryph/issues/46136/?project=17
        /^undefined is not an object \(evaluating 'r\.play\(\).catch'\)$/,
        /^TypeError: Cannot read property 'play' of undefined$/,
        // 忽略掉https://sentry.hypergryph.com/organizations/hypergryph/issues/46286/?project=17
        /^__TB_API__CB_\d+_\d+ is not defined$/,
        // 容易被广告脚本、插件触发
        "SecurityError",
        "Blocked a frame with origin",
        "Permission denied",
        "The operation is insecure",

        // 异常的跨域脚本
        "Script error.",

        // 常见浏览器 bug
        "ResizeObserver loop",
        "ResizeObserver loop limit exceeded",

        // 被动监听器 / 滚动事件
        "Cannot read properties of null",
        "undefined is not an object",

        // 网络中断类
        "NetworkError",
        "Failed to fetch",
        "Load failed",

        // Promise canceled（React 18 很常见）
        "AbortError",
        "The user aborted a request",
    ],

    // 过滤第三方域名的错误
    denyUrls: [
        /extensions\//i, // Chrome 插件
        /^chrome:\/\//i,
        /crxfs:/i,
        /moz-extension:/i,

        /googletagmanager\.com/i,
        /google-analytics\.com/i,
        /connect\.facebook\.net/i,
        /newrelic\.com/i,
        /doubleclick\.net/i,
        /adsbygoogle/i,
        /cloudfront\.net/i,
    ],
})
